import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from '@mui/material';

interface Customer {
  id: string;
  name: string;
  email: string;
  phone: string;
  initials?: string;
}

interface ScheduleAppointmentModalProps {
  isOpen: boolean;
  onRequestClose: (hasData?: boolean) => void;
  onSuccess: () => void;
  leadId?: string;
  customer?: Customer;
}

const ScheduleAppointmentModal: React.FC<ScheduleAppointmentModalProps> = ({
  isOpen,
  onRequestClose,
  onSuccess,
  leadId,
  customer,
}) => {
  return (
    <Dialog open={isOpen} onClose={() => onRequestClose()} maxWidth="sm" fullWidth>
      <DialogTitle>Schedule Appointment</DialogTitle>
      <DialogContent>
        <Typography>
          Schedule appointment modal for lead {leadId}. This will be implemented later.
        </Typography>
        {customer && (
          <Typography variant="body2" sx={{ mt: 2 }}>
            Customer: {customer.name}
          </Typography>
        )}
      </DialogContent>
      <DialogActions>
        <Button onClick={() => onRequestClose()}>Cancel</Button>
        <Button variant="contained" onClick={onSuccess}>
          Schedule
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ScheduleAppointmentModal;








